module.exports = __webpack_public_path__ + "img/BRONCE.634a2d05.png";